import statusLabel from './statusLabel'

const inviteAdvisor = {
  statusLabel,
}

export default inviteAdvisor
